import { FC } from 'react';
import { NumberUtils, Tr } from '@utils';
import { AdditionalService, PaymentRecurrence, PaymentType } from '@services';
import { Box, Grid, Stack } from '@mui/material';
import { VoltaageModalDialog, IVoltaageModalDialogProps, StripedTableCell } from '@components/common';
import { PackageDealAndServiceLogoViewer } from '../PackageDealAndServiceLogoViewer';

const getPaymentRecurrenceText = (recurrence?: PaymentRecurrence) => {
	if (recurrence === PaymentRecurrence.ONE_TIME) {
		return <Tr.Portal path="package-deal.recurrence-one-time" />;
	} else if (recurrence === PaymentRecurrence.RECURRING) {
		return <Tr.Portal path="package-deal.recurrence-recurring" />;
	}
};
const getPaymentTypeText = (type?: PaymentType) => {
	if (type === PaymentType.PER_VEHICLE) {
		return <Tr.Portal path="package-deal.payment-type-per-vehicle" />;
	} else if (type === PaymentType.PER_FLEET) {
		return <Tr.Portal path="package-deal.payment-type-per-fleet" />;
	} else if (type === PaymentType.PER_DRIVER) {
		return <Tr.Portal path="package-deal.payment-type-per-driver" />;
	}
};

export interface IPackageDealServiceDetailDialogProps extends IVoltaageModalDialogProps {
	entity?: AdditionalService;
}

export const PackageDealServiceDetailDialog: FC<IPackageDealServiceDetailDialogProps> = ({ entity, ...props }) => {
	return (
		<VoltaageModalDialog
			title={
				<Stack direction="row" alignItems="center" spacing={2}>
					<PackageDealAndServiceLogoViewer src={entity?.logoUrl || ''} />
					<Box>{entity?.name || ''}</Box>
				</Stack>
			}
			titleProps={{ sx: { justifyContent: 'center' } }}
			dividers
			{...props}
		>
			{entity ? (
				<Box sx={{ paddingX: 10, paddinTop: 3, paddingBottom: 5 }}>
					<Grid container>
						<StripedTableCell title={<Tr.Portal path="package-deal.service-summary" />}>
							{entity.summary || '-'}
						</StripedTableCell>
						<StripedTableCell title={<Tr.Portal path="package-deal.service-description" />}>
							{entity.description || '-'}
						</StripedTableCell>
						<StripedTableCell title={<Tr.Portal path="package-deal.type" />} greyBg>
							{entity.serviceType || '-'}
						</StripedTableCell>
						<StripedTableCell title={<Tr.Portal path="package-deal.supplier" />} greyBg>
							{entity.supplier || '-'}
						</StripedTableCell>
						<StripedTableCell title={<Tr.Portal path="package-deal.price" />}>
							{NumberUtils.formatAsPrice(entity.price, { pureDefault: true })}
						</StripedTableCell>
						<StripedTableCell title={<Tr.Portal path="package-deal.payment" />}>
							<Stack direction="row" divider={<span> - </span>}>
								{getPaymentRecurrenceText(entity.paymentRecurrence)}
								{getPaymentTypeText(entity.paymentType)}
							</Stack>
						</StripedTableCell>
					</Grid>
				</Box>
			) : null}
		</VoltaageModalDialog>
	);
};
